import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const LinkedIn = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M12.0833 1H3.91667C2.30608 1 1 2.30608 1 3.91667V12.0833C1 13.6939 2.30608 15 3.91667 15H12.0833C13.6945 15 15 13.6939 15 12.0833V3.91667C15 2.30608 13.6945 1 12.0833 1ZM5.66667 12.0833H3.91667V5.66667H5.66667V12.0833ZM4.79167 4.927C4.22817 4.927 3.77083 4.46617 3.77083 3.898C3.77083 3.32983 4.22817 2.869 4.79167 2.869C5.35517 2.869 5.8125 3.32983 5.8125 3.898C5.8125 4.46617 5.35575 4.927 4.79167 4.927ZM12.6667 12.0833H10.9167V8.81433C10.9167 6.84967 8.58333 6.99842 8.58333 8.81433V12.0833H6.83333V5.66667H8.58333V6.69625C9.39767 5.18775 12.6667 5.07633 12.6667 8.14058V12.0833Z"
        fill="#1275B1"
      />
    </svg>
  )
})

export default LinkedIn
